export default __webpack_public_path__ + "static/media/adidas.83df8153.png";